var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWindshield = function SvgWindshield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M3.137 6.906c.307-1.298 1.588-2.142 2.93-1.946 1.787.262 4.112.54 5.933.54 1.821 0 4.146-.278 5.933-.54 1.342-.196 2.623.648 2.93 1.946l1.89 7.995c.34 1.438-.632 2.84-2.085 3-2.533.278-6.025.599-8.668.599-2.643 0-6.135-.32-8.668-.6-1.453-.16-2.425-1.56-2.085-3zM8.455 9l-2.637 2.636m6.772.864-2.772 2.773M12 9.09l-6.182 6.183",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgWindshield as ReactComponent };
export default __webpack_public_path__ + "4003c789d5f31a2359d9c0d322ea271e.svg";